/**
 * T112: usePromptVariables Hook
 * Query hook for fetching prompt variables
 */

import { useQuery } from '@tanstack/react-query'
import { getPromptVariables } from '@/services/prompts'
import { queryKeys } from '@/lib/query-keys'

export function usePromptVariables(promptId: string, enabled = true) {
  return useQuery({
    queryKey: queryKeys.prompts.variables(promptId),
    queryFn: () => getPromptVariables(promptId),
    enabled,
  })
}
